const LogoutIcon = () => {
    return (
        <svg
            id="Group_8337"
            data-name="Group 8337"
            xmlns="http://www.w3.org/2000/svg"
            width="25"
            height="25"
            viewBox="0 0 20 20.43"
        >
            <g id="Group_8337-2" data-name="Group 8337">
                <path
                    id="Path_3555"
                    data-name="Path 3555"
                    d="M9.687,19.618h1.929a2.233,2.233,0,0,0,2.233-2.234V3.072A2.233,2.233,0,0,0,11.616.838H9.687Z"
                    transform="translate(-0.149 -0.013)"
                    fill="#d6d6d6"
                />
                <path
                    id="Path_3556"
                    data-name="Path 3556"
                    d="M9.687,19.618h1.929a2.233,2.233,0,0,0,2.233-2.234V3.072A2.233,2.233,0,0,0,11.616.838H9.687Z"
                    transform="translate(-0.149 -0.013)"
                    fill="none"
                    stroke="#d6d6d6"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1"
                />
                <path
                    id="Path_3557"
                    data-name="Path 3557"
                    d="M13.814,15.464v2.029c0,1.422-.787,2.574-1.757,2.574H2.132c-.97,0-1.757-1.152-1.757-2.574V2.948c0-1.421.787-2.573,1.757-2.573h9.926c.97,0,1.757,1.152,1.757,2.573V5.1"
                    transform="translate(-0.006 -0.006)"
                    fill="none"
                    stroke="#0c3b8d"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="0.75"
                />
                <line
                    id="Line_305"
                    data-name="Line 305"
                    y1="19.417"
                    transform="translate(9.538 0.391)"
                    fill="none"
                    stroke="#0c3b8d"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="0.75"
                />
                <path
                    id="Path_3558"
                    data-name="Path 3558"
                    d="M20.118,10a.46.46,0,0,1,0,.65L17.2,13.565a.459.459,0,0,1-.65-.649l2.6-2.594-2.6-2.594a.459.459,0,0,1,.65-.65Z"
                    transform="translate(-0.253 -0.107)"
                    fill="#0c3b8d"
                />
                <rect
                    id="Rectangle_1263"
                    data-name="Rectangle 1263"
                    width="8.258"
                    height="0.918"
                    transform="translate(11.283 9.756)"
                    fill="#0c3b8d"
                />
            </g>
        </svg>
    );
};

export default LogoutIcon;
